
import { format, parseISO } from "date-fns";

interface AvailabilitySlot {
  date: string;
  endDate?: string;
  slots: string[];
  recurring?: {
    days: string[];
    until: string;
  };
}

interface AvailabilityDisplayProps {
  slots: AvailabilitySlot[];
}

export const AvailabilityDisplay = ({ slots }: AvailabilityDisplayProps) => {
  if (!slots || slots.length === 0) {
    return null;
  }

  const formatSlot = (slot: AvailabilitySlot) => {
    if (slot.recurring) {
      return `Every ${slot.recurring.days.join(", ")} until ${format(parseISO(slot.recurring.until), "MMM d")} • ${slot.slots[0]}`;
    }

    // Handle date range
    const startDate = parseISO(slot.date);
    if (slot.endDate && slot.endDate !== slot.date) {
      const endDate = parseISO(slot.endDate);
      return `${format(startDate, "MMM d")}-${format(endDate, "MMM d")} • ${slot.slots[0]}`;
    }

    // Single date
    return `${format(startDate, "MMM d")} • ${slot.slots[0]}`;
  };

  return (
    <div className="space-y-2">
      {slots.map((slot, index) => (
        <div key={index} className="text-muted-foreground">
          {formatSlot(slot)}
        </div>
      ))}
    </div>
  );
};
